import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
  Text,
} from "@fluentui/react-components";
import { ChevronDownRegular } from "@fluentui/react-icons";
import { SelectItem } from "library/types";

import { Flex } from "components/styled";
import { useAppTheme } from "hooks/useAppTheme";
type Props = {
  languageOptions: SelectItem[];
  onSelect: (event: React.FormEvent<HTMLDivElement>, option?: SelectItem, index?: number) => void;
  selectedLanguage: string;
};

const formatNationKey = (value: string) => {
  const nationKey = value.toString().split("-")[1];
  return nationKey === "Latn" ? "RS" : nationKey;
}

export function SelectLanguage({ languageOptions, onSelect, selectedLanguage }: Props) {
  const theme = useAppTheme();

  const selected = languageOptions.find((option) => option.value === selectedLanguage);
  const nationKey = formatNationKey(String(selected?.value ));

  return (
    <Menu positioning={"below-end"} persistOnItemClick>
      <MenuTrigger disableButtonEnhancement>
        <Button
          data-help="app-settings-language"
          style={{
            paddingLeft: "0",
            justifyContent: "flex-start",
          }}
          icon={<ChevronDownRegular fontSize={16} />}
          iconPosition="after"
          appearance="transparent"
        >
          <SelectedLang nationKey={nationKey} isSelected item={selected} />
        </Button>
      </MenuTrigger>

      <MenuPopover>
        <MenuList>
          {languageOptions.map((option) => {
            const nationKey = formatNationKey(String(option.value ));
            const selected = option.value?.toString() === selectedLanguage;
            return (
              <MenuItem
                key={option.value}
                onClick={(e) => {
                  onSelect(e, option);
                }}
                style={{
                  background: selected ? theme.palette.purpleLight : "inherit",
                  color: selected ? theme.palette.purpleDark : "inherit",
                }}
              >
                <SelectedLang nationKey={nationKey} isSelected={selected} item={option} />
              </MenuItem>
            );
          })}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}

const SelectedLang = ({ nationKey, isSelected, item }) => {
  return (
    <Flex $justify="flex-start" align="center">
      <img
        src={`https://flagsapi.com/${nationKey}/flat/24.png`}
        width="24"
        height="20"
        alt={item?.value?.toString()}
      />
      <Text weight={isSelected ? "bold" : "regular"}>{item?.text}</Text>
    </Flex>
  );
};
